import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchPartFeatures, PartFeaturesDto } from "./fetchPartFeatures.api";

export const partFeaturesQuery = (id: string | undefined) => ({
  queryKey: queryKeys.parts.features(id),
  queryFn: () => fetchPartFeatures(id),
  staleTime: STALE_TIME,
});

export const getPartFeaturesQueryData = (
  queryClient: QueryClient,
  id: string,
): PartFeaturesDto | null | undefined => {
  return queryClient.getQueryData<PartFeaturesDto | null>(queryKeys.parts.features(id));
};

type PartFeaturesQueryDataUpdater =
  | PartFeaturesDto
  | null
  | undefined
  | ((old: PartFeaturesDto | null | undefined) => PartFeaturesDto | null | undefined);

export const setPartFeaturesQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: PartFeaturesQueryDataUpdater,
): PartFeaturesDto | null | undefined => {
  return queryClient.setQueryData<PartFeaturesDto | null>(queryKeys.parts.features(id), updater);
};
